/**
 * Displays a scoring-brief decision as a MUI Chip with an icon.
 */
import { css } from '@emotion/core';
import { Chip, Tooltip } from '@material-ui/core';
import { Check, Close, HelpOutline } from '@material-ui/icons';
import React from 'react';

import { Decision } from 'shared/models/profile-score';

const DECISION_DISPLAY: Record<Decision, { icon: React.ReactElement; label: string }> = {
    MAYBE: { icon: <HelpOutline />, label: 'Maybe' },
    REACH_OUT: { icon: <Check />, label: 'Reach Out' },
    SKIP: { icon: <Close />, label: 'Skip' }
};

interface DecisionScoreProps {
    decision: Decision;
    onClick?: (e: React.MouseEvent) => void;
    tooltip?: string;
}

const styles = css`
    background-color: white !important;
    &:hover {
        background-color: #efefef !important;
    }
`;

export const DecisionScore: React.FC<DecisionScoreProps> = ({ decision, onClick, tooltip }) => {
    const display = DECISION_DISPLAY[decision];
    if (decision && !display) {
        throw new Error(`Invalid decision score: ${decision}`);
    }

    const chip = <Chip icon={display.icon} label={display.label} variant="outlined" css={styles} onClick={onClick} />;

    return tooltip !== undefined ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip;
};
